module.exports = __webpack_public_path__ + "img/Italian-Software-Information-step-3.5d83d2b8.png";